import { Analytics } from '@cobliteam/analytics';
import Badge from '@cobliteam/colib-ui/Badge';
import Button from '@cobliteam/colib-ui/Button';
import { useTranslation } from '@cobliteam/i18n';
import Icon from '@cobliteam/ui/icons';

export interface MultiSelectVehicleGroupsSidebarTriggerProps {
  totalSelectedGroups: number;
  isOpen: boolean;
}

const MultiSelectVehicleGroupSidebarTrigger = ({ totalSelectedGroups, isOpen }: MultiSelectVehicleGroupsSidebarTriggerProps) => {
  const { t } = useTranslation('multiselects');

  const onDropdownOpen = () => {
    Analytics.track('Global Filter Opened');
  };

  return (
    <Button
      aria-label={t('groups.filter_groups')}
      aria-expanded={isOpen}
      variant={isOpen ? 'secondary' : 'outline'}
      className='shrink-0 max-sm:size-8 max-sm:px-0'
      size='sm'
      onClick={onDropdownOpen}
    >
      <Icon name='filter' size='sm' />
      <span className='hidden sm:inline'>{t('groups.filter_groups')}</span>
      {totalSelectedGroups > 0 && (
        <Badge variant='secondary' size='sm' className='max-sm:hidden'>
          {totalSelectedGroups}
        </Badge>
      )}
      <Icon name='chevron-down' size='sm' className='max-sm:hidden' />
    </Button>
  );
};

export default MultiSelectVehicleGroupSidebarTrigger;
